import { render, staticRenderFns } from "./checkbox-button.vue?vue&type=template&id=32a41ace&"
import script from "./checkbox-button.vue?vue&type=script&lang=js&"
export * from "./checkbox-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports